import analytics from '../cdpAnalytics'

export function analyticsTrackZoomMedia(control, zoomedOnWeb) {
  const { snapshot } = control
  const { zoomedItem } = control
  if (snapshot) {
    let mediaType
    if (zoomedItem === 'promptMedia' && snapshot.media) {
      mediaType = snapshot.media.type
    } else if (zoomedItem === 'choiceA' && snapshot.choices[0] && snapshot.choices[0].media) {
      mediaType = snapshot.choices[0].media.type
    } else if (zoomedItem === 'choiceB' && snapshot.choices[1] && snapshot.choices[1].media) {
      mediaType = snapshot.choices[1].media.type
    } else if (zoomedItem === 'choiceC' && snapshot.choices[2] && snapshot.choices[2].media) {
      mediaType = snapshot.choices[2].media.type
    } else if (zoomedItem === 'choiceD' && snapshot.choices[3] && snapshot.choices[3].media) {
      mediaType = snapshot.choices[3].media.type
    }
    if (zoomedOnWeb) {
      analytics.track('Web NP zoom media', {
        zoomedItem,
        mediaType,
      })
    } else {
      analytics.track('NP zoom media', {
        zoomedItem,
        mediaType,
      })
    }
  }
}
